<template>
  <v-dialog v-model="dialog.show" persistent max-width="600">
    <v-card>
      <v-card-title class="pl-0 pr-0 pt-0 ml-0 mr-0 mt-0">
        <v-toolbar :color="getAppBarColor">
          <v-toolbar-title>
            <v-row dense justify="center" align="center">
              <v-col cols="12">
                <span class="align-center">
                  <p class="white--text">{{ dialog.title }}</p>
                </span>
              </v-col>
            </v-row>
          </v-toolbar-title>
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="form.data.descricao"
                label="Descrição"
                :rules="[rules.required]"
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="form.data.conteudo"
                label="Conteúdo"
                :rules="[rules.required]"
                :counter="1000"
              />
            </v-col>
            <v-col cols="12">
              <SelectEmpresa
                :multiple="true"
                @onChanged="form.data.empresas = $event"
                :empresasSelecionadas="empSelect"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="form.data.tipo"
                :items="content.tipo"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="form.data.ordem" label="Ordem" :rules="[rules.required]" />
            </v-col>

            <v-col cols="12">
              <v-checkbox v-model="form.data.copy" label="Permitir Cópia" color="blue darken-2" />

              <v-checkbox v-model="form.data.ativo" label="Ativo" color="blue darken-2" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="!editMode"
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="save()"
        >Salvar</v-btn>

        <v-btn
          v-if="editMode"
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="update()"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="dialog.show = false"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import { Scripts } from "@/services/materiais";

export default {
  name: "DialogScripts",
  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa")
  },

  data() {
    return {
      editMode: false,
      idScript: "",

      dialog: {
        title: "Adicionar Script",
        show: false
      },

      content: {
        tipo: ["Whatsapp", "Email", "Telefone", "SMS"]
      },
      empSelect: [],
      form: {
        data: {
          descricao: "",
          conteudo: "",
          tipo: "Whatsapp",
          copy: true,
          ativo: true,
          empresas: [],
          ordem: 1
        }
      },

      rules: rules
    };
  },

  methods: {
    show(edit = false, scriptObj) {
      this.editMode = edit;
      this.dialog.title = "Adicionar Script";
      this.resetFields();

      if (edit) {
        this.dialog.title = "Editar Script";
        this.idScript = scriptObj.id;
        this.form.data.descricao = scriptObj.descricao;
        this.form.data.conteudo = scriptObj.conteudo;
        this.form.data.tipo = scriptObj.tipo;
        this.form.data.copy = scriptObj.copy;
        this.form.data.ativo = scriptObj.ativo;
        this.empSelect.push(...scriptObj.empresas);
        this.form.data.ordem = scriptObj.ordem;
      }

      this.dialog.show = true;
    },

    async save() {
      if (!this.$refs.form.validate()) return;

      try {
        const result = await new Scripts().createScript(this.form.data);
        this.$toast.success(result.message);
        this.$refs.form.reset();
        this.dialog.show = false;
        this.$emit("saved");
      } catch (error) {
        this.$toast.error(error);
      }
    },

    async update() {
      if (!this.$refs.form.validate()) return;

      try {
        const result = await new Scripts().updateScript(
          this.idScript,
          this.form.data
        );
        this.$toast.success(result.message);
        this.$refs.form.reset();
        this.dialog.show = false;
        this.$emit("saved");
      } catch (error) {
        this.$toast.error(error);
      }
    },

    resetFields() {
      this.idScript = "";
      this.form.data.descricao = "";
      this.form.data.conteudo = "";
      this.form.data.tipo = "Whatsapp";
      this.form.data.copy = true;
      this.form.data.ativo = true;
      this.empSelect = [];
      this.form.data.empresas = null;
      this.form.data.ordem = 1;
    }
  }
};
</script>
